export const getFieldByTitle = (title: string): string => {
    switch (title) {
        case '#':
            return '_id';
        case 'Title':
            return 'title';
        case 'Discount':
            return 'isActiveDiscount';
        case 'Category':
            return 'categorytitle'
        case 'Sub-Category':
            return 'subcategorytitle';
        case 'Sub-category':
            return 'title'
        case 'First Name':
            return 'name';
        case "Last Name":
            return 'surname';
        case "Email address":
            return 'email';
        case "Phone":
            return "phone";
        case "Status":
            return "isBlocked"
        case "Competition":
            return "competition"
        case "Product":
            return "name"
        case "Number of tickets":
            return "ticketsCount"
        case "Draw Date":
            return "drawDate"
        case "Role":
            return "role";
        case "Date":
            return "createdDate";
        case "Description":
            return "description"
        case "Amount":
            return "amount"
        case "First name":
            return "name"
        case "Last name":
            return "surname"
        case "Spent/Needed to spend":
            return "neededSpend";
        case "Competition#":
            return 'competitionNumber'
        case "Lifestyle Prizes":
            return "lifestylePrizes"
        case "User":
            return "fromUserName"
        case "Start Date":
            return "startAt";
        case "Finish Date":
            return "endsAt"
        case "Tickets purchased":
            return "orders.ticketsCount";
        case "Price":
            return "ticketPrice";
        case "Created Date":
            return "createdAt";
        case "Name":
            return "name";
        case "Total Cost":
            return "total"
        default:
            return title
    }
}